// auth.service.ts
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { NavController, ToastController } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: Observable<firebase.User>;
  windowRef                     : any;
  public verificationId         : string  = "";

  constructor(
    public afs: AngularFirestore,
    public toastCtrl: ToastController,
    private firebaseAuth: AngularFireAuth,
    public navCtrl  : NavController) {
    this.user = firebaseAuth.authState;
  }


  signup(email: string, password: string) {
    this.firebaseAuth
      .auth
      .createUserWithEmailAndPassword(email, password)
      .then(value => {
        console.log('Success!', value);
        this.navCtrl.navigateForward('/home');
      })
      .catch(err => {
        this.showToast('Something went wrong:');
      });
  }

  login(email: string, password: string) {
    this.firebaseAuth
      .auth
      .signInWithEmailAndPassword(email, password)
      .then(value => {
        console.log('Nice, it worked!');
        this.navCtrl.navigateForward('/home');
      })
      .catch(err => {
        this.showToast('Something went wrong:');
        console.log('Something went wrong:',err.message);
      });
  }

  logout() {
  var self = this;
  self.firebaseAuth
      .auth
      .signOut();

      var query = self.afs.collection("DeviceCollection").ref
         .where('uId', '==', localStorage.id);
      query.get().then(function(querySnapshot) {
        if(!querySnapshot.empty) {
          var docId   = querySnapshot.docs[0].id;
          self.afs.collection("DeviceCollection").doc(docId).delete().then(function() {
            console.log('DeviceCollection' + docId);
          }).catch(function(error) {
            console.log('DeviceCollection' + error);
          });
        } 
      })

      //location.reload();
      localStorage.clear();
      this.navCtrl.navigateRoot("/login");
  }

  async showToast(message) {
    if (message) {
      const toast = await this.toastCtrl.create({
          message,
          duration: 1500,
          position: 'bottom'
      });
      toast.present();
    }
  }
}
